/**
 * @generated SignedSource<<2a64ed46222f1bd637e6530db71da8dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ImageFormat = "AI" | "BMP" | "DXF" | "GIF" | "JPEG" | "PDF" | "PNG" | "SVG";
export type printingMethodEditor_PrintTypeDetailQuery$variables = {
  id: string;
};
export type printingMethodEditor_PrintTypeDetailQuery$data = {
  readonly designEffectTemplates: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly previewDesignEffect: {
      readonly type: number;
    };
  }>;
  readonly printType: {
    readonly backgroundRemoverSettings: {
      readonly isEditEnabled: boolean;
      readonly isHiddenMode: boolean;
      readonly isUploadEnabled: boolean;
    } | null;
    readonly dpi: number;
    readonly id: string;
    readonly maxColors: number | null;
    readonly name: string;
    readonly outputDesignEffect: {
      readonly blendMode: string;
      readonly enhanceBlendMode: boolean;
      readonly imageEffectParameterValues: ReadonlyArray<{
        readonly name: string;
        readonly value: string;
      }>;
      readonly imageEffectTypeName: string;
      readonly opacity: number;
      readonly textColor: string | null;
      readonly type: number;
    } | null;
    readonly outputFileFormats: ReadonlyArray<ImageFormat> | null;
    readonly patternSetting: {
      readonly allowOffsetChange: boolean;
      readonly allowSpacingChange: boolean;
      readonly isImageEnabled: boolean;
      readonly isTextEnabled: boolean;
      readonly presets: ReadonlyArray<number> | null;
    } | null;
    readonly previewDesignEffect: {
      readonly blendMode: string;
      readonly enhanceBlendMode: boolean;
      readonly imageEffectParameterValues: ReadonlyArray<{
        readonly name: string;
        readonly value: string;
      }>;
      readonly imageEffectTypeName: string;
      readonly opacity: number;
      readonly textColor: string | null;
      readonly type: number;
    } | null;
    readonly restrictions: {
      readonly allowBold: boolean | null;
      readonly allowChangeFontSize: boolean | null;
      readonly allowGradientTextColors: boolean;
      readonly allowImageGalleryTextColors: boolean;
      readonly allowImageUploadTextColors: boolean;
      readonly allowItalic: boolean | null;
      readonly allowLetterSpacing: boolean | null;
      readonly allowLineSpacing: boolean | null;
      readonly allowShadows: boolean | null;
      readonly allowTextStroke: boolean | null;
      readonly canAddText: boolean | null;
      readonly canChangeSvgColors: boolean | null;
      readonly canStretchImages: boolean | null;
      readonly canUseImageFilters: boolean | null;
      readonly canUseTextArt: boolean | null;
      readonly curvedText: boolean | null;
      readonly defaultColor: string | null;
      readonly enableVectorize: boolean;
      readonly maxNrImages: number | null;
      readonly showImageProvider: boolean | null;
      readonly textBox: boolean | null;
      readonly uploadRestrictions: {
        readonly isAiAllowed: boolean | null;
        readonly isEpsAllowed: boolean | null;
        readonly isFacebookAllowed: boolean | null;
        readonly isInstagramAllowed: boolean | null;
        readonly isJpgAllowed: boolean | null;
        readonly isPdfAllowed: boolean | null;
        readonly isPdfWithRasterAllowed: boolean | null;
        readonly isPngAllowed: boolean | null;
        readonly isSvgAllowed: boolean | null;
        readonly isUserImageAllowed: boolean | null;
        readonly resizeLargePdf: boolean | null;
      } | null;
      readonly uppercase: boolean | null;
    } | null;
  } | null;
};
export type printingMethodEditor_PrintTypeDetailQuery = {
  response: printingMethodEditor_PrintTypeDetailQuery$data;
  variables: printingMethodEditor_PrintTypeDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "blendMode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "enhanceBlendMode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "opacity",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "textColor",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "imageEffectTypeName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageEffectParameterValue",
    "kind": "LinkedField",
    "name": "imageEffectParameterValues",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "PrintType",
    "kind": "LinkedField",
    "name": "printType",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dpi",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outputFileFormats",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxColors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PartPrintTypeRestriction",
        "kind": "LinkedField",
        "name": "restrictions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canAddText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "textBox",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUseTextArt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "curvedText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowBold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowItalic",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uppercase",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowChangeFontSize",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowLetterSpacing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowLineSpacing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowTextStroke",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowShadows",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defaultColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowGradientTextColors",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowImageUploadTextColors",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowImageGalleryTextColors",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showImageProvider",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canChangeSvgColors",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUseImageFilters",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableVectorize",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canStretchImages",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxNrImages",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UploadRestriction",
            "kind": "LinkedField",
            "name": "uploadRestrictions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUserImageAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPngAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isJpgAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSvgAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPdfAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPdfWithRasterAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isEpsAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAiAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFacebookAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isInstagramAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resizeLargePdf",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PrintTypeBackgroundRemoverSetting",
        "kind": "LinkedField",
        "name": "backgroundRemoverSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isUploadEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isHiddenMode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEditEnabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PrintTypePatternSetting",
        "kind": "LinkedField",
        "name": "patternSetting",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "presets",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTextEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isImageEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowSpacingChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowOffsetChange",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DesignEffect",
        "kind": "LinkedField",
        "name": "previewDesignEffect",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DesignEffect",
        "kind": "LinkedField",
        "name": "outputDesignEffect",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "DesignEffectTemplate",
    "kind": "LinkedField",
    "name": "designEffectTemplates",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "DesignEffect",
        "kind": "LinkedField",
        "name": "previewDesignEffect",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "printingMethodEditor_PrintTypeDetailQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "printingMethodEditor_PrintTypeDetailQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "2189ccf928a43a19a248fc2f89b6be49",
    "id": null,
    "metadata": {},
    "name": "printingMethodEditor_PrintTypeDetailQuery",
    "operationKind": "query",
    "text": "query printingMethodEditor_PrintTypeDetailQuery(\n  $id: ID!\n) {\n  printType(id: $id) {\n    id\n    name\n    dpi\n    outputFileFormats\n    maxColors\n    restrictions {\n      canAddText\n      textBox\n      canUseTextArt\n      curvedText\n      allowBold\n      allowItalic\n      uppercase\n      allowChangeFontSize\n      allowLetterSpacing\n      allowLineSpacing\n      allowTextStroke\n      allowShadows\n      defaultColor\n      allowGradientTextColors\n      allowImageUploadTextColors\n      allowImageGalleryTextColors\n      showImageProvider\n      canChangeSvgColors\n      canUseImageFilters\n      enableVectorize\n      canStretchImages\n      maxNrImages\n      uploadRestrictions {\n        isUserImageAllowed\n        isPngAllowed\n        isJpgAllowed\n        isSvgAllowed\n        isPdfAllowed\n        isPdfWithRasterAllowed\n        isEpsAllowed\n        isAiAllowed\n        isFacebookAllowed\n        isInstagramAllowed\n        resizeLargePdf\n      }\n    }\n    backgroundRemoverSettings {\n      isUploadEnabled\n      isHiddenMode\n      isEditEnabled\n    }\n    patternSetting {\n      presets\n      isTextEnabled\n      isImageEnabled\n      allowSpacingChange\n      allowOffsetChange\n    }\n    previewDesignEffect {\n      type\n      blendMode\n      enhanceBlendMode\n      opacity\n      textColor\n      imageEffectTypeName\n      imageEffectParameterValues {\n        name\n        value\n      }\n    }\n    outputDesignEffect {\n      type\n      blendMode\n      enhanceBlendMode\n      opacity\n      textColor\n      imageEffectTypeName\n      imageEffectParameterValues {\n        name\n        value\n      }\n    }\n  }\n  designEffectTemplates {\n    id\n    name\n    previewDesignEffect {\n      type\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3f52cae10c0b26fe76b7c3ad9207ed66";

export default node;
